import React from 'react'
import './AboutContent.css'
import { Link } from 'react-router-dom'
import about1 from '../../resources/assets/about1.jpg'
import about2 from '../../resources/assets/about2.jpg'

const AboutContent = () => {
  return (
    <div className='about'>
        <div className='left'>
            <h1>Who AM I?</h1>
            <p>I'm a software developer. I create responsive secure websites for my client.</p>
            <Link to='/contact'>
                <button className='btn'>Contact</button>
            </Link>
        </div>
        <div className='right'>
            <div className='img-container'>
                <div className='img-stack top'>
                    <img src={about1} className='img' alt='true'/>
                </div>
                <div className='img-stack bottom'>
                    <img src={about2} className='img' alt='true'/>
                </div>
            </div>
        </div>
    </div>
  )
}

export default AboutContent